import React from 'react'
import { Layout } from '../../components'
import Login from '../../views/Login/Login'

const Index = () => {
  return <Login />
}

Index.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

export default Index
